import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index"),
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/home"),
      },
      {
        path: "/contactUs",
        name: "contactUs",
        component: () => import("@/views/us/us"),
      },

      {
        path: "/register",
        name: "register",
        component: () => import("@/views/login/login"),
      },
      {
        path: "/practices",
        name: "practices",
        component: () => import("@/views/exam/practices"),
      },
      {
        path: "/exams",
        name: "exams",
        component: () => import("@/views/exam/exams"),
      },

      {
        path: "/exam-details",
        name: "exam-details",
        component: () => import("@/views/exam/examDetails"),
      },
      {
        path: "/networking",
        name: "networking",
        component: () => import("@/views/networking/index"),
        children: [
          {
            path: "home",
            name: "home",
            component: () => import("@/views/networking/home"),
          },
          {
            path: "skillscompetition/:type",
            name: "skillscompetition",
            component: () => import("@/views/networking/skillscompetition"),
          },
          {
            path: "skillslist/:type",
            name: "skillslist",
            component: () => import("@/views/networking/skillslist"),
          },
          {
            path: "liveclass",
            name: "liveclass",
            component: () => import("@/views/networking/liveclass"),
          },
          {
            path: "expertteam",
            name: "expertteam",
            component: () => import("@/views/networking/expertteam"),
          },
          {
            path: "detail",
            name: "detail",
            component: () => import("@/views/networking/detail"),
          },
        ],
      },
      {
        path: "/networkingsingup/index",
        name: "networkingsingup",
        component: () => import("@/views/networkingsingup/index"),
          meta: {
        
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/networkingsingup/project",
        name: "networkingsingup-project",
        component: () => import("@/views/networkingsingup/project"),
         meta: {
        
          showFooter: false, // 此页面隐藏底部
        },
      },

      {
        path: "/course",
        name: "course",
        component: () => import("@/views/networking/course"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/signup",
        name: "signup",
        component: () => import("@/views/signup/index"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/signup-details",
        name: "signup-details",
        component: () => import("@/views/signup/detail"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/signup-form",
        name: "signup-form",
        component: () => import("@/views/signup/form"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/choosegroup",
        name: "choosegroup",
        component: () => import("@/views/signup/choosegroup"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/communicationgroup",
        name: "communicationgroup",
        component: () => import("@/views/signup/communicationgroup"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/registrationends",
        name: "registrationends",
        component: () => import("@/views/signup/registrationends"),
        meta: {
          showHeader: false, // 此页面隐藏头部
          showFooter: false, // 此页面隐藏底部
        },
      },
      {
        path: "/start/:id",
        name: "start",
        component: () => import("@/views/exam/startExam"),
      },
      {
        path: "/exam-record",
        name: "exam-record",
        component: () => import("@/views/exam/examRecords"),
      },
            {
        path: "/mis-notebook",
        name: "mis-notebook",
        component: () => import("@/views/exam/misNotebook"),
      },
      {
        path: "/knowledge",
        name: "knowledge",
        component: () => import("@/views/exam/knowledge"),
      },

      {
        path: "/courses",
        name: "courses",
        component: () => import("@/views/exam/courses"),
      },
      {
        path: "/course-details",
        name: "course-details",
        component: () => import("@/views/exam/courseDetails"),
      },
      {
        path: "/account",
        name: "account",
        component: () => import("@/views/personal/account"),
      },
      {
        path: "/password",
        name: "password",
        component: () => import("@/views/personal/password"),
      },
      {
        path: "/incorrect",
        name: "incorrect",
        component: () => import("@/views/exam/incorrect"),
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: () => import("@/views/personal/resetPassword"),
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login"),
  },
  {
    path: "/wxLogin",
    name: "wxLogin",
    component: () => import("@/views/login/wxLogin"),
  },

  {
    path: "*",
    redirect: "/home",
  },
];
export default new Router({
  mode: "history", // 去掉url中的#
  routes: constantRouterMap,
});
